// src/components/InstagramFeed.js
import React, { useEffect } from 'react';
import './InstagramFeed.css'; // Styles pour cette section

// Array of Instagram post data (just permalinks needed)
const instagramPostsData = [
  { permalink: "https://www.instagram.com/p/Cl0pKXNM2lY/?utm_source=ig_embed&amp;utm_campaign=loading" },
  { permalink: "https://www.instagram.com/p/Cl0pPSvsTM7/?utm_source=ig_embed&amp;utm_campaign=loading" },
  // Ajoutez d'autres objets avec des permaliens ici si nécessaire
];

function InstagramFeed() {
  useEffect(() => {
    const scriptId = 'instagram-embed-script';
    let script = document.getElementById(scriptId);

    const processInstagramEmbeds = () => {
      if (window.instgrm && typeof window.instgrm.Embeds.process === 'function') {
        window.instgrm.Embeds.process();
      }
    };

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = "https://www.instagram.com/embed.js"; // URL sécurisée en HTTPS
      script.async = true;
      script.defer = true; // Diffère l'exécution après l'analyse HTML
      script.onload = processInstagramEmbeds; // Traiter les embeds une fois le script chargé
      document.body.appendChild(script);
    } else {
      // Si le script est déjà présent (ex: navigation dans une SPA)
      // et que window.instgrm est disponible, essayer de traiter.
      processInstagramEmbeds();
    }
  }, []); // Charger le script une seule fois lors du montage du composant

  // Ce useEffect s'exécute après le montage du composant et à chaque fois que instagramPostsData change.
  // Il garantit que les embeds Instagram sont traités après que les blockquotes sont dans le DOM.
  useEffect(() => {
    if (window.instgrm && typeof window.instgrm.Embeds.process === 'function') {
      window.instgrm.Embeds.process();
    }
  }, [instagramPostsData]); // Retraiter si la liste des posts change (important si dynamique)

  return (
    <section id="instagram-feed" className="instagram-feed-section">
      <div className="container">
        <h2 className="section-title">Suivez Notre Actualité sur Instagram</h2>
        <p className="section-subtitle instagram-subtitle">
          Dernières créations, inspirations et nouveautés du salon directement depuis notre feed !
        </p>
        <div className="instagram-posts-container">
          {instagramPostsData.map((post, index) => (
            <blockquote
              key={index}
              className="instagram-media" // Classe ciblée par embed.js
              data-instgrm-permalink={post.permalink}
              data-instgrm-captioned // Inclure si vous voulez afficher les légendes par défaut
              data-instgrm-version="14"
              // Les styles qui étaient en ligne dans vos anciens codes (max-width, etc.)
              // doivent maintenant être appliqués via InstagramFeed.css à la classe .instagram-media
              // si le rendu par défaut d'Instagram ne suffit pas.
              // Voir les commentaires dans InstagramFeed.css ci-dessous.
            >
              {/* Le contenu sera chargé ici par le script embed.js d'Instagram */}
            </blockquote>
          ))}
        </div>
        <a
          href="https://www.instagram.com/studio_ambre32/" // Assurez-vous que c'est le bon profil
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-follow-button"
        >
          Suivre @studio_ambre32
        </a>
      </div>
    </section>
  );
}

export default InstagramFeed;